export function UserAgreement({
	setBillingInfo,
	billingInfo,
	billingInfoErrors,
	checkValidation,
}) {
	const handleInput = (e, name) => {
		e.persist();

		setBillingInfo(prev => ({ ...prev, [name]: e.target.checked }));
		checkValidation({ [name]: e.target.checked }, false);
	};

	return (
		<>
			<div>
				<div className="wp-checkout-userAgreement">
					<input
						id="userAgreement"
						type="checkbox"
						checked={billingInfo?.mailchimp}
						onChange={e => handleInput(e, 'mailchimp')}
						tabIndex={13}
					/>
					<label
						htmlFor="userAgreement"
						className="userAgreement-checkbox"
					></label>
					<label
						htmlFor="userAgreement"
						className="wp-checkout-font-sm userAgreement-content"
					>
						Get free tips, tutorials and discount codes from us
					</label>
				</div>

				<div className="wp-checkout-userAgreement">
					<input
						id="userAgreement2"
						type="checkbox"
						checked={billingInfo?.edd_agree_to_terms}
						onChange={e => handleInput(e, 'edd_agree_to_terms')}
						tabIndex={14}
					/>
					<label
						htmlFor="userAgreement2"
						className="userAgreement-checkbox"
					></label>
					<label
						htmlFor="userAgreement2"
						className="wp-checkout-font-sm userAgreement-content"
					>
						I Agree With{' '}
						<a
							href="https://wpdeveloper.com/terms-and-conditions"
							target="_blank"
							className="text-decerotion-underline"
						>
							Terms & Conditions
						</a>{' '}
						and{' '}
						<a
							target="_blank"
							href="https://wpdeveloper.com/privacy-policy"
							className="text-decerotion-underline"
						>
							Privacy Policy
						</a>
					</label>
					<p className="wp-checkout-form-input-error wp-checkout-font-sm">
						{billingInfoErrors?.edd_agree_to_terms}
					</p>
				</div>
			</div>
		</>
	);
}
